import { useMemo } from 'react'

import {
  getAgeGroupOptions,
  getParentalRatingOptions
} from '../../../lib/parental-ratings'
import getBirthYearOptions from '../../../utils/getBirthYearOptions'

export const useProfileOptions = ({
  ageGroupsData,
  appConfig,
  parentalRatingsData
}) => {
  const ageGroupOptions = useMemo(
    () => getAgeGroupOptions(ageGroupsData || []),
    [ageGroupsData]
  )
  const parentalRatingOptions = useMemo(
    () => getParentalRatingOptions(parentalRatingsData || []),
    [parentalRatingsData]
  )
  const birthYearOptions = useMemo(
    () => getBirthYearOptions(appConfig?.values, false),
    [appConfig?.values]
  )

  return {
    ageGroupOptions,
    birthYearOptions,
    parentalRatingOptions
  }
}
